import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from 'rxjs';
import { CrudService } from "./crud.service";
import { GenericResponse, DestinoEnvio, SearchDestinoEnvioRequest, SearchDestinoEnvioResponse, SaveDestinoEnvioDto } from "../model/index";
import { SharedFunctions } from 'src/app/shared/shared.functions';

@Injectable({
  providedIn: 'root'
})
export class DestinoEnvioService extends CrudService<DestinoEnvio, number, SaveDestinoEnvioDto, SearchDestinoEnvioRequest> {

  constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions) {
    super(_http,'destinoEnvio', sharedFunctions);

  }

  getAnonymous(encryptedId: string): Observable<any> {
    return this._http.get<any>(this._serviceUrl + '/GetList/'+encryptedId, this.httpOptions);
  }
}